export const SLICE_NAME = 'experimentsV2';
